// /src/pages/PaymentSuccess.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getLangFromPath, buildPathWithLang } from "../i18n/lang";
import ReactGA from "react-ga4";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const loc = useLocation();
  const { t } = useTranslation("common");
  React.useEffect(() => {
    try {
      const sp = new URLSearchParams(loc.search || window.location.search || '');
      const status = (sp.get('status') || 'success').toLowerCase();
      const invoiceId = sp.get('invoice_id') || sp.get('invoice') || sp.get('id') || '';
      ReactGA.event({
        category: 'Checkout',
        action: status === 'success' ? 'PaymentSuccess' : 'PaymentReturn',
        label: invoiceId.slice(0, 64)
      });
    } catch {}
  }, [loc.search]);

  const lang = getLangFromPath(loc.pathname);

  const goBack = () => {
    nav(buildPathWithLang(lang, "/service/silence/settings"));
  };

  return (
    <div style={{maxWidth:700, margin:"48px auto", background:"#fff", borderRadius:16, padding:36, boxShadow:"0 2px 12px #0001"}}>
      <h2 style={{fontWeight:800, fontSize:30, marginBottom:12}}>
        {t("pay_success.title")}
      </h2>
      <p>{t("pay_success.note")}</p>
      <div style={{marginTop:20}}>
        <button
          onClick={goBack}
          style={{padding:"10px 18px", border:"none", borderRadius:8, background:"#00723a", color:"#fff", fontWeight:700, cursor:"pointer"}}
        >
          {t("pay_success.back_to_silence")}
        </button>
      </div>
    </div>
  );
}
